import React, { useEffect, useState } from "react";
import { FaSave, FaPlus, FaTimes, FaForward, FaTrash } from "react-icons/fa";
import {
  PrimaryButton,
  SecondaryButton,
  DangerButton,
} from "../../UI/DesignStandards";

export const ActionBar = ({
  onSave,
  onSaveAndCreateAnother,
  onCancel,
  onSkip = null,
  skipLabel = "Skip team",
  onDelete = null,
  deleteLabel = "Delete team",
  isSaving = false,
  canSave = true,
  hasChanges = false,
  saveLabel = "Save Team",
  showSaveAndCreateAnother = true,
  confirmResetKey = "",
}) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  useEffect(() => {
    setConfirmDelete(false);
  }, [confirmResetKey]);

  return (
    <div className="border-t border-brand-charcoal/10 pt-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <SecondaryButton
            onClick={onCancel}
            icon={FaTimes}
            disabled={isSaving}
            className="!px-3 !py-2 text-sm"
          >
            Cancel
          </SecondaryButton>

          {hasChanges && (
            <span className="text-sm text-brand-muted">
              You have unsaved changes
            </span>
          )}
        </div>

        <div className="flex items-center gap-2">
          {onSkip ? (
            <SecondaryButton
              onClick={onSkip}
              icon={FaForward}
              disabled={isSaving}
              className="!px-3 !py-2 text-sm"
            >
              {skipLabel}
            </SecondaryButton>
          ) : null}

          {onDelete && confirmDelete ? (
            <div className="flex items-center gap-2">
              <span className="text-sm text-red-600 font-medium whitespace-nowrap">
                Delete this signup?
              </span>
              <DangerButton
                onClick={() => {
                  setConfirmDelete(false);
                  onDelete();
                }}
                disabled={isSaving}
                className="!px-3 !py-2 text-sm rounded-lg"
              >
                Yes
              </DangerButton>
              <SecondaryButton
                onClick={() => setConfirmDelete(false)}
                disabled={isSaving}
                className="!px-3 !py-2 text-sm"
              >
                No
              </SecondaryButton>
            </div>
          ) : onDelete ? (
            <DangerButton
              onClick={() => setConfirmDelete(true)}
              icon={FaTrash}
              disabled={isSaving}
              className="!px-3 !py-2 text-sm rounded-lg"
            >
              {deleteLabel}
            </DangerButton>
          ) : null}

          {showSaveAndCreateAnother ? (
            <SecondaryButton
              onClick={onSaveAndCreateAnother}
              icon={FaPlus}
              disabled={!canSave || isSaving}
              loading={isSaving ? true : undefined}
              className="!px-3 !py-2 text-sm"
            >
              Save & Create Another
            </SecondaryButton>
          ) : null}

          <PrimaryButton
            onClick={onSave}
            icon={FaSave}
            disabled={!canSave || isSaving}
            loading={isSaving ? true : undefined}
          >
            {isSaving ? "Saving..." : saveLabel}
          </PrimaryButton>
        </div>
      </div>

      <div className="mt-4 text-xs text-brand-muted text-center">
        <div className="flex items-center justify-center gap-4">
          <span>Ctrl+Enter: Save Team</span>
          {showSaveAndCreateAnother ? (
            <span>Ctrl+Shift+Enter: Save & Create Another</span>
          ) : null}
          <span>Escape: Cancel</span>
        </div>
      </div>
    </div>
  );
};
